import React from "react";
import PropTypes from "prop-types";

import ClientsListView from "../../../../../Company-portal/Clients/ClientsListView";
import useAdminCompanyClientsList from "../../../../ClientManagement/hooks/useAdminCompanyClientsList";

import "../../../../../Company-portal/Clients/Clients.scss";
import "../../../../../Company-portal/TeamsPermissions/TeamsPermissions.scss";

const CompanyClientsTab = ({ companyId }) => {
  const listProps = useAdminCompanyClientsList(companyId);

  return <ClientsListView {...listProps} embedded />;
};

CompanyClientsTab.propTypes = {
  companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default CompanyClientsTab;
